(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sollast-header"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initLoc(scope) {
    (scope || document).querySelectorAll('[data-slh-loc]').forEach(function (dd) {
      if (dd.hasAttribute('data-bound')) return;
      dd.setAttribute('data-bound', '1');
      var btn = dd.querySelector('[data-slh-loc-btn]');
      var panel = dd.querySelector('[data-slh-loc-panel]');
      var form = dd.closest('form');
      var input = form && form.querySelector('[data-slh-loc-input]');
      function close() { panel.hidden = true; dd.classList.remove('is-open'); btn.setAttribute('aria-expanded', 'false'); }
      btn.addEventListener('click', function (e) {
        e.stopPropagation();
        var open = panel.hidden;
        panel.hidden = !open;
        dd.classList.toggle('is-open', open);
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
      dd.querySelectorAll('[data-slh-loc-opt]').forEach(function (opt) {
        opt.addEventListener('click', function () {
          if (input) input.value = opt.getAttribute('data-value');
          close();
          if (form) form.submit();
        });
      });
      document.addEventListener('click', function (e) { if (!dd.contains(e.target)) close(); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
    });
  }
  function init(scope) {
    (scope || document).querySelectorAll('[data-slh-burger]').forEach(function (btn) {
      if (btn.hasAttribute('data-bound')) return;
      btn.setAttribute('data-bound', '1');
      var panel = btn.closest('.sl-header').querySelector('[data-slh-mobile]');
      btn.addEventListener('click', function () { panel.hidden = !panel.hidden; });
    });
    initLoc(scope);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sollast-home"] && !Shopify.designMode) return;
  try {
    
(function () {
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var noIO = typeof IntersectionObserver === 'undefined';
  var io = noIO ? null : new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) { e.target.classList.add('is-visible'); io.unobserve(e.target); }
    });
  }, { threshold: 0.12, rootMargin: '0px 0px -60px 0px' });
  function init(root) {
    (root || document).querySelectorAll('.sollast').forEach(function (el) { el.classList.add('sl-anim'); });
    (root || document).querySelectorAll('.sollast [data-stagger]').forEach(function (c) {
      if (c.hasAttribute('data-stagger-bound')) return;
      c.setAttribute('data-stagger-bound', '1');
      Array.prototype.forEach.call(c.children, function (child, i) {
        child.setAttribute('data-reveal', '');
        child.style.transitionDelay = Math.min(i * 70, 420) + 'ms';
      });
    });
    (root || document).querySelectorAll('.sollast [data-reveal], .sollast [data-title-reveal]').forEach(function (el) {
      if (el.hasAttribute('data-reveal-bound')) return;
      el.setAttribute('data-reveal-bound', '1');
      if (reduced || noIO) { el.classList.add('is-visible'); return; }
      io.observe(el);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sollast-page-about"] && !Shopify.designMode) return;
  try {
    
(function () {
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var noIO = typeof IntersectionObserver === 'undefined';
  var io = noIO ? null : new IntersectionObserver(function (entries) {
    entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-visible'); io.unobserve(e.target); } });
  }, { threshold: 0.12, rootMargin: '0px 0px -60px 0px' });

  function init(root) {
    (root || document).querySelectorAll('.sl-about [data-stagger]').forEach(function (c) {
      if (c.hasAttribute('data-stagger-bound')) return;
      c.setAttribute('data-stagger-bound', '1');
      Array.prototype.forEach.call(c.children, function (child, i) {
        child.setAttribute('data-reveal', '');
        child.style.animationDelay = Math.min(i * 70, 420) + 'ms';
      });
    });
    (root || document).querySelectorAll('.sl-about [data-reveal]').forEach(function (el) {
      if (el.hasAttribute('data-reveal-bound')) return;
      el.setAttribute('data-reveal-bound', '1');
      if (reduced || noIO) { el.classList.add('is-visible'); return; }
      io.observe(el);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();

  } catch(e) { console.error(e); }
})();
})();
